module.exports = __webpack_public_path__ + "static/denner-cb79dae9a9139dd12157e29e4fd34f59.png";